import React from 'react'

import { Helmet } from 'react-helmet'

import Header from '../components/header'
import Card from '../components/card'
import Footer from '../components/footer'
import './isometric.css'

const Isometric = (props) => {
  return (
    <div className="isometric-container">
      <Helmet>
        <title>Isometric - BharatKarade</title>
        <meta
          name="description"
          content="Hii i'm Bharat Karade, i have over 11+ years of experience in Game UI Design and graphic designs 2D in-depth knowledge of Drawing."
        />
        <meta property="og:title" content="Isometric - BharatKarade" />
        <meta
          property="og:description"
          content="Hii i'm Bharat Karade, i have over 11+ years of experience in Game UI Design and graphic designs 2D in-depth knowledge of Drawing."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/37270ff6-c20f-4c60-89cf-ed199b10be0f/dec54fbc-2bef-42e2-a2f0-7c793b6d3599?org_if_sml=1"
        />
      </Helmet>
      <Header rootClassName="header-root-class-name5"></Header>
      <section className="isometric-container1 Fade_in_up1">
        <span className="isometric-text">Isometric Arts</span>
        <div id="Grider" className="isometric-container2">
          <a
            href="https://iili.io/HVx6fRa.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6fRa.jpg"
              Image_name="bharat karade 22"
              image_name="bharat karade 22"
              rootClassName="card-root-class-name31"
              className="isometric-component01"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6qOJ.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6qOJ.jpg"
              Image_name="bharat karade 97f3ee225377"
              image_name="bharat karade 97f3ee225377"
              rootClassName="card-root-class-name32"
              className="isometric-component02"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6BDv.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6BDv.jpg"
              Image_name="bharat karade 984fc822537"
              image_name="bharat karade 984fc822537"
              rootClassName="card-root-class-name33"
              className="isometric-component03"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6KHg.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6KHg.jpg"
              Image_name="bharat karade a3498c22537713 56314519e9ba9"
              image_name="bharat karade a3498c22537713 56314519e9ba9"
              rootClassName="card-root-class-name34"
              className="isometric-component04"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6oVp.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6oVp.jpg"
              Image_name="bharat karade art school"
              image_name="bharat karade art school"
              rootClassName="card-root-class-name35"
              className="isometric-component05"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6nxR.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6nxR.jpg"
              Image_name="bharat karade backery bucher shop"
              image_name="bharat karade backery bucher shop"
              rootClassName="card-root-class-name36"
              className="isometric-component06"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6xiN.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6xiN.jpg"
              Image_name="bharat karade beach house"
              image_name="bharat karade beach house"
              rootClassName="card-root-class-name37"
              className="isometric-component07"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6IfI.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6IfI.jpg"
              Image_name="bharat karade botanical garden"
              image_name="bharat karade botanical garden"
              rootClassName="card-root-class-name38"
              className="isometric-component08"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx65Rs.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx65Rs.jpg"
              Image_name="bharat karade building bgvillage"
              image_name="bharat karade building bgvillage"
              rootClassName="card-root-class-name39"
              className="isometric-component09"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6Tlt.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6Tlt.jpg"
              Image_name="bharat karade c09bdf2253771"
              image_name="bharat karade c09bdf2253771"
              rootClassName="card-root-class-name40"
              className="isometric-component10"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6uUX.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6uUX.jpg"
              Image_name="bharat karade castle"
              image_name="bharat karade castle"
              rootClassName="card-root-class-name41"
              className="isometric-component11"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6RJn.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6RJn.jpg"
              Image_name="bharat karade chinees garden v1"
              image_name="bharat karade chinees garden v1"
              rootClassName="card-root-class-name77"
              className="isometric-component12"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx67OG.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx67OG.jpg"
              Image_name="bharat karade coldstore smith"
              image_name="bharat karade coldstore smith"
              rootClassName="card-root-class-name76"
              className="isometric-component13"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6Ybf.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6Ybf.jpg"
              Image_name="bharat karade emmbacy"
              image_name="bharat karade emmbacy"
              rootClassName="card-root-class-name75"
              className="isometric-component14"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6cx4.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6cx4.jpg"
              Image_name="bharat karade firework shop"
              image_name="bharat karade firework shop"
              rootClassName="card-root-class-name74"
              className="isometric-component15"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6lWl.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6lWl.jpg"
              Image_name="bharat karade house1"
              image_name="bharat karade house1"
              rootClassName="card-root-class-name73"
              className="isometric-component16"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx60s2.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx60s2.jpg"
              Image_name="bharat karade house2"
              image_name="bharat karade house2"
              rootClassName="card-root-class-name72"
              className="isometric-component17"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6EfS.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6EfS.jpg"
              Image_name="bharat karade house3"
              image_name="bharat karade house3"
              rootClassName="card-root-class-name71"
              className="isometric-component18"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6Mg9.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6Mg9.jpg"
              Image_name="bharat karade marchent house2"
              image_name="bharat karade marchent house2"
              rootClassName="card-root-class-name70"
              className="isometric-component19"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6G07.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6G07.jpg"
              Image_name="bharat karade opera house"
              image_name="bharat karade opera house"
              rootClassName="card-root-class-name69"
              className="isometric-component20"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6WJe.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6WJe.jpg"
              Image_name="bharat karade shop1"
              image_name="bharat karade shop1"
              rootClassName="card-root-class-name68"
              className="isometric-component21"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6X5u.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6X5u.jpg"
              Image_name="bharat karade temple5"
              image_name="bharat karade temple5"
              rootClassName="card-root-class-name67"
              className="isometric-component22"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVx6hOb.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVx6hOb.jpg"
              Image_name="bharat karade temple house"
              image_name="bharat karade temple house"
              rootClassName="card-root-class-name29"
              className="isometric-component23"
            ></Card>
          </a>
        </div>
      </section>
      <Footer rootClassName="footer-root-class-name5"></Footer>
    </div>
  )
}

export default Isometric
